/**
 * @author Matěj Grabovský <matej.grabovsky@ki-wi.cz>
 * @author Radek Liška <ing.radek.liska@gmail.com>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

// @ts-check

import { defineComponent } from 'vue';

// @ts-ignore Není to ESM.
import template from './setup-success.html';

import focus from '../focus/focus-directive';
import CountdownRoot from '../countdown/countdown-root';

export default defineComponent({
  name: 'SetupSuccess',
  template,
  components: { CountdownRoot },
  directives: { focus },
  emits: {
    finish() {}
  },
  methods: {
    finish() {
      this.$emit('finish');
    },
    onClick() {
      this.finish();
    },
    onEnd() {
      this.finish();
    }
  },
  props: {
    time: { type: Number, required: true }
  }
});
